import { Component, OnInit,Output, EventEmitter } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-survey-modal',
  templateUrl: './survey-modal.component.html',
  styleUrls: ['./survey-modal.component.css']
})
export class SurveyModalComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  private sub = new Subscription(); 
  constructor(
    private _amplitudeService: AmplitudeAnalyticsService,
    private _commonUtil: CommonUtil,
    private rootScopeService: RootScopeService) {
      const rootScopeServiceSub = this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
      this.sub.add(rootScopeServiceSub);
     }
  cloudBasePath: string;
  
  @Output() onClose:EventEmitter<any>=new EventEmitter();
  ngOnInit() {    
    this._amplitudeService.logEvent({elementName: 'Page', action: 'Loaded'}, 'Survey');
    this.cloudBasePath=environment.cloudBasePath;
  }

  takeSurveyNow(){
    this._amplitudeService.logEvent({elementName: 'Take Survey', action: 'Click'}, 'Survey');
    this.onClose.emit({
      "showSurveyPopup": true,
      "isSurveyTaken": true
    });
    this._commonUtil.rootScopeData.popupData.showSurveyPopup = false;
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSfhEzRqm2zJd_6muq415AONlYzu8VssxtVRx2B8ZOqkUIQ_1A/viewform','_blank');
  }

  takeSurveyLater(){
    this._amplitudeService.logEvent({elementName: 'Maybe Later', action: 'Click'}, 'Survey');
    this.onClose.emit({
      "showSurveyPopup": true,
      "isSurveyTaken": false
    });
    this._commonUtil.rootScopeData.popupData.showSurveyPopup = true;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
